<template>
  <div class="callout-wrap max-w-6xl mx-auto pt-8 md:pt-12 px-3 md:px-5 relative mb-8 md:mb-16">
    <div class="callout rounded-sm text-sm md:text-base mt-3 bg-regalblue-600 py-6">
      <div class="text-white text-xl px-6 md:px-8 pb-2">
        <strong class="text-2xl">
          Announcing our latest product offering!
        </strong>
        <div>
          The
          <a href="/products/CISynchronizer" class="underline"
            ><em
              >Lansweeper to ServiceNow <abbr title="Configuration Item">CI</abbr> Synchronizer</em
            ></a
          >
          is a Freeware ServiceNow application that synchronises your IT assets from Lansweeper
          (on-premise edition) into your ServiceNow
          <abbr title="Configuration Management Database">CMDB</abbr>.
        </div>
        <a
          href="/products/CISynchronizer"
          class="button button--primary button--sm font-bold mt-3 no-underline"
          title="Learn more about, or downlaod the Lansweeper to ServiceNow CI Synchronizer"
        >
          Learn more
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeCallout',
  components: {}
};
</script>

<style lang="scss" scoped>
.callout-wrap {
  a {
    color: #fff !important;
    // text-decoration: underline !important;
    &:active,
    &:focus {
      color: #fff;
    }
    &:visited {
      color: rgba(#fff, 0.8);
    }
  }
  .callout {
    $useColr: $PriOrange;
    position: relative;
    font-size: 17px;
    font-weight: 400;
    font-family: $brand-font-family;
    width: 100%;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5) !important;
    background: #fff;
    // padding: 20px 20px 20px 20px;
    svg {
      position: absolute;
      top: 50%;
      left: 15px;
      transform: translateY(-50%);
      path {
        stroke: $useColr;
      }
    }
  }
}
</style>
